import { render, staticRenderFns } from "./ProfilBase.vue?vue&type=template&id=1dd96c58&scoped=true&"
import script from "./ProfilBase.vue?vue&type=script&lang=js&"
export * from "./ProfilBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd96c58",
  null
  
)

export default component.exports